import { Signal } from "signals";
import { Autoplay } from "slotworks/services/autoplay/autoplay";
import { Currency } from "slotworks/services/currency/currency";
import { SoundManager } from "slotworks/services/sound/sound-manager";
import { LocalStorage } from "slotworks/services/storage/local-storage";
import { Transaction } from "slotworks/services/transaction/transaction";
import { Translations } from "slotworks/services/translations/translations";

export class Services {
    public static StorageType = LocalStorage;
    public static SoundManagerType = SoundManager;
    public static CurrencyType = Currency;
    public static TranslationsType = Translations;
    public static TransactionType = Transaction;
    public static AutoplayType = Autoplay;

    public static storage: LocalStorage;
    public static sound: SoundManager;
    public static currency: Currency;
    public static translations: Translations;
    public static transaction: Transaction;
    public static autoplay: Autoplay;

    public static onInit: Signal = new Signal();

    public static init() {
        this.storage = new Services.StorageType();
        this.sound = new Services.SoundManagerType();
        this.currency = new Services.CurrencyType();
        this.translations = new Translations();
        this.transaction = new Services.TransactionType();
        this.autoplay = new Services.AutoplayType();

        Services.onInit.dispatch();
    }
}
